import React from 'react'
export default (Component) => {
  return class ComponentWithResizer extends React.Component {
    constructor (props) {
      super(props)
      this.state = {
        width: 0
      }
    }

    componentDidMount () {
      window.addEventListener('resize', this.resize.bind(this))
      this.setState({
        width: window.innerWidth
      })
      this.resize()
    }

    resize () {
      this.setState({
        width: window.innerWidth,
        isMobile: window.innerWidth <= 740
      })
    }

    render () {
      return <Component {...this.props} {...this.state} />
    }
  }
}
